// extracted by mini-css-extract-plugin
module.exports = {"formWrap":"src-pages-guide-component-TaxBureauStep-__index__formWrap--27rtS"};